export const mainDescription = {
  // ----------------------------------- indoor

  amnesia: `La fleur de CBD Amnesia est une variété de cannabis Sativa réputée pour son taux élevé de cannabidiol (CBD).
  Les têtes de la fleur Amnesia CBD sont généralement denses et recouvertes de trichomes, les petits cristaux qui contiennent les cannabinoïdes, y compris le CBD. Les couleurs varient du vert au jaune pâle, avec des pistils orangés qui ajoutent une touche de couleur à l'ensemble.
   En termes d'odeur, la fleur Amnesia CBD offre souvent un mélange complexe de parfums, allant des notes terreuses et boisées aux nuances citronnées et épicées. Certains décrivent son arôme comme étant rafraîchissant et énergisant.`,

  gelato: `La Gelato CBD est une variété de cannabis spécialement cultivée pour sa teneur élevée en cannabidiol
  (CBD). Cette variété offre une expérience similaire en termes d'arômes et de saveurs, avec des notes sucrées, et de
  fruits, mais sans les effets psychotropes associés au THC, ces têtes sont vertes et très compact. La Gelato CBD est
  prisée pour ses potentiels bienfaits thérapeutiques, offrant la possibilité de soulager le stress, l'anxiété et les
  tensions physiques sans induire d'altérations cognitives. Découvrez la Gelato CBD pour une expérience agréable et
  apaisante, mariant les qualités aromatiques distinctives de la Gelato avec les bienfaits du CBD.`,

  cerealMilk: `Un classique américain revisité. Cereal Milk séduit par son profil sucré et crémeux, où les notes de lait vanillé se mêlent à une pointe de fruits confits.
  Une fleur indoor dense, généreusement résineuse, au manucurage soigné.`,

  Biscotti: `Biscotti porte bien son nom : une gourmandise pâtissière relevée d'épices douces et d'un fond boisé.
  L'une des variétés les plus abouties de notre sélection indoor, reconnaissable à ses reflets violacés et sa structure serrée.`,

  TropicalDream: `Descriptif : Une explosion de fruits tropicaux — mangue, ananas, agrumes mûrs.
  Tropical Dream est la plus expressive de la gamme indoor, avec un nez immédiat et persistant. Idéale pour ceux qui recherchent un profil frais et lumineux.`,

  trimDescr: `La Trim est un mélange de l’ensemble des variétés disponibles
  passé au tamis afin de ne récupérer que les fines parties des fleurs. Cette trim
  est hautement concentré en pistils et pollen et donc riche en cannabinoïdes et terpènes.
  Ce produit est composé uniquement de fleurs séchées de chanvre. Il est proposé en tant que matière première brute.`,

  // ----------------------------------- Greenhouse

  ogKush: `L'incontournable. OG Kush déploie un profil brut et minéral, entre terre humide, pin et zestes de citron.
  Cultivée sous serre, elle offre l'authenticité de la génétique originale à un rapport qualité-prix imbattable.`,

  Lemon: `Un nez de citron franc, presque acidulé, soutenu par un fond herbacé.
  Lemon Greenhouse est la valeur sûre du quotidien : nette, régulière, facile à apprécier.`,

  // ----------------------------------- hasch

  marocainDescr: `Le Hash Marocain CBD est spécialement conçu pour offrir les bienfaits du cannabidiol (CBD) sans les effets
  psychoactifs associés au tétrahydrocannabinol (THC). Cet extrait de résine de chanvre est obtenu à partir de variétés
  spécifiques cultivées pour leur richesse en CBD. Le Hash Marocain CBD offre une texture soyeuse et une couleur
  caractéristique. Avec des arômes terreux, épicés. Ce hash CBD propose une expérience aromatique authentique.
  Il est apprécié pour ses potentiels bienfaits thérapeutiques, offrant la possibilité de soulager le stress,
  les tensions musculaires et favorisant une sensation de relaxation.`,

  pollenDescr: `Le hash jaune CBD se présente sous forme de résine compacte  qui est caractérisée par sa couleur jaune et une
  concentration significative de cannabidiol (CBD)En termes de saveur, le hash jaune CBD offre des notes terreuses et épicées
  gelato`,

  filtreDescr: `La résine CBD Filtré est issue d'une extraction à froid qui est ensuite filtrée 3 fois.
  Ce procédé permet d'enlever un maximum de matière végétale et d'atteindre une concentration d’environ 75% de
  cannabidiol et moins de 0.2% THC. Texture: Résines, crumble, concentrées.`,

  iceOLatorDescr: `Le pollen est une résine concentrée de fleurs et de feuilles de chanvre et constitue
  un moyen efficace d'obtenir les bienfaits du CDB. La résine CBD Ice O lator   est issue d'une extraction à froid
  des trims et des têtes inférieure de la plante qui est ensuite filtrée 4 fois à l’aide de tamis avec des mailles
  de microns de plus en plus fines. Ce procédé permet d'enlever un maximum de matière végétale et d'atteindre une
  concentration d’environ 75% de cannabidiol et moins de 0.2%.`
};
